import { a as f } from "./chunk-BaseElement-GuTcWj1p.js";
import { W as m } from "./chunk-WithApiClient-C8TxqOg8.js";
import { h as p } from "./chunk-task-4yBfzZiu.js";
import { x as l } from "./chunk-lit-element-fTUROFeD.js";
import { t as y } from "./chunk-custom-element-BugcqQdL.js";
import { n as d } from "./chunk-property-DOK3RaQn.js";
import { r as w } from "./chunk-query-all-DnnEScl3.js";
import { o as _ } from "./chunk-unsafe-html-Cdilvd_C.js";
var P = Object.defineProperty, g = Object.getOwnPropertyDescriptor, a = (t, r, e, i) => {
  for (var o = i > 1 ? void 0 : i ? g(r, e) : r, u = t.length - 1, h; u >= 0; u--)
    (h = t[u]) && (o = (i ? h(r, e, o) : h(o)) || o);
  return i && o && P(r, e, o), o;
};
const v = `#graphql
  fragment ProductVariantNode on ProductVariant {
    product {
      handle
    }
  }

  query getProductVariantsFromNode($id: ID!) {
    node(id: $id) {
      id
      ...ProductVariantNode
    }
  }
`, c = {}, s = {};
let n = class extends m(
  f
) {
  constructor() {
    super(...arguments), this.template = "product-card", this.urlPostfix = "", this.checkIfResponseHasLayout = (t) => t.match(/html|body/), this._loadVariantByIdTask = new p(this, {
      task: async ([t]) => {
        if (!t)
          throw new Error("No variantId provided");
        if (s[t])
          return s[t];
        const { node: r } = await this.$api.client.storefront({
          body: {
            query: v,
            variables: {
              id: `gid://shopify/ProductVariant/${t}`
            }
          }
        });
        if (r && "product" in r)
          return s[t] = r.product.handle, s[t];
        throw new Error("No product handle found");
      },
      args: () => [this.variantId]
    }), this.loadProductHandleView = new p(this, {
      task: async ([t]) => {
        if (!t)
          throw new Error("No handle provided");
        if (c[this.cacheKey])
          return c[this.cacheKey];
        const r = await this.$api.client.shopify(
          `products/${t}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "text/html"
            }
          },
          {
            params: {
              view: this.template,
              layout: "none",
              ...this.variantId && {
                variant: this.variantId
              }
            }
          }
        );
        if (this.checkIfResponseHasLayout(r))
          throw new Error("Invalid response");
        if (r)
          return c[this.cacheKey] = r, r;
        throw new Error("No product found");
      },
      args: () => [
        this.handle || this._loadVariantByIdTask.value,
        this.variantId
      ]
    });
  }
  createRenderRoot() {
    return this;
  }
  get cacheKey() {
    return `${this.handle}-${this.variantId}-${this.template}`;
  }
  _renderPostfix() {
    if (window.__VENDORS__ && !window.__VENDORS__.nosto.enabled || !this.urlPostfix) return;
    const t = Array.from(this.productUrls);
    if (t.length !== 0)
      for (const r of t) {
        const e = r;
        if (e && (e.href || e.getAttribute("product-url"))) {
          const i = new URL(
            e.href || e.getAttribute("product-url")
          ), o = this.urlPostfix.split("=");
          o.length === 2 ? i.searchParams.append(o[0], o[1]) : console.error(
            'urlPostfix does not contain exactly one "=" character.'
          ), e.href ? e.href = i.toString() : e.setAttribute("product-url", i.toString());
        }
      }
  }
  async updated() {
    this._renderPostfix();
  }
  render() {
    return l`
      ${this.loadProductHandleView.render({
      complete: (t) => {
        if (t)
          return this.setAttribute("data-loaded", "true"), l`${_(t)}`;
      }
    })}
    `;
  }
};
a([
  d({ type: String, attribute: "variant-id" })
], n.prototype, "variantId", 2);
a([
  d({ type: String })
], n.prototype, "handle", 2);
a([
  d({ type: String })
], n.prototype, "template", 2);
a([
  d({ type: String, attribute: "url-postfix" })
], n.prototype, "urlPostfix", 2);
a([
  w("[data-product-url]")
], n.prototype, "productUrls", 2);
n = a([
  y("dynamic-product-card")
], n);
export {
  n as DynamicProductCard
};
